function copyFromPreviousFields({ input, state }) {
  let registration = state.get('client.registration')
  let copyAddressType = state.get(
    `client.registrating.current.${input.previousType}`
  )
  let currentType = state.get(`client.registrating.current.${input.type}`)
  let copy = {}
  registration.forEach(field => {
    let performAdd = true
    if (field.excludeFrom && field.excludeFrom.length > 0) {
      if (field.excludeFrom.indexOf(input.type) !== -1) {
        performAdd = false
      }
    }
    if (performAdd) {
      if (copyAddressType[field.identifier]) {
        copy[field.identifier] = {
          ...copyAddressType[field.identifier]
        }
      } else {
        copy[field.identifier] = {
          ...currentType[field.identifier]
        }
      }
    }
  })
  state.set(`client.registrating.current.${input.type}`, copy)
  state.set(`client.registrating.refresh.${input.type}`, true)
}

export default copyFromPreviousFields



// WEBPACK FOOTER //
// ./src/modules/user/actions/copyFromPreviousFields.js